import React from 'react';
import PropTypes from 'prop-types';
import { Button, Text } from 'components';
import { useNavigate } from 'react-router';
import { AlertOutlined } from '@ant-design/icons';

const PresentarQueja = ({ plantilla }) => {
  const navigate = useNavigate();

  const handleOnClick = () => {
    if (plantilla) {
      navigate('/protesta/nueva', { state: { plantilla } });
    }
  };

  return (
    <Button
      shape="round"
      $accent
      block
      onClick={handleOnClick}
    >
      <Text>
        Presentar Queja
      </Text>
      <AlertOutlined />
    </Button>
  );
};

PresentarQueja.defaultProps = {
  plantilla: null,
};

PresentarQueja.propTypes = {
  plantilla: PropTypes.shape({}),
};

export default PresentarQueja;
